import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { API_URL } from "../../config";
import moment from "moment";
import CustomSelect from "../../Components/CustomSelect";
import EmptyState from "../../Components/EmptyState";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import Loader from "../Loader/Loader";
import Home from "./Home";
import Test from "./Test";
import VerifiedPlayer from "./VerifiedPlayer";
import Notification from "./Notification";
import Ticket from "./Ticket";
import { toast } from "react-toastify";
import RefferalList from "./RefferalList";
import History from "./HistoryList";
import OtherDetails from "./OtherDetails";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const filterSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
    padding: "2px 8px",
    fontSize: "0.95rem",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? "#ffc107" 
      : state.isFocused 
      ? "rgba(255, 193, 7, 0.1)" 
      : "#fff",
    color: state.isSelected ? "#000" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#ffc107",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

export default function PlayerList() {
  const { showPage, setShowPage, accessObject, addNewPlayer, setAddNewPlayer } =
    useAppContext();
  const { socket } = useAppContext();

  // console.log("accessObject player list :::", accessObject);
  
  const [alert, setAlert] = React.useState(null);
  const [rowValue, setRowValue] = React.useState();
  console.log("rowValue::: ", rowValue);
  const [value, setValue] = React.useState(0);
  // const [tableData, setTableData] = React.useState([]);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(true);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [filteredData, setFilteredData] = React.useState([]);

  const [historyData, setHistoryData] = React.useState([]);
  const [changeStatus, setChangeStatus] = React.useState(3);
  const [changeDeviceType, setChangeDeviceType] = React.useState(2);
  const [searchEmail, setSearchEmail] = React.useState("");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState(1);
  const [testPage, setTestPage] = React.useState(false);
  const [showBotForm, setShowBotForm] = React.useState(false);

  const BotFormSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    amount: Yup.number()
      .required("Amount is required")
      .positive("Amount must be positive"),
    image: Yup.number().required("Image is required"),
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
  };

  const onPaginationChange = (start, end) => {
  };

  const handleClearFilters = () => {
    setPageNumber(1);
    setRecordLength(10);
    setChangeStatus(3);
    setChangeDeviceType(2);
    setSearchEmail("");
  };

  React.useEffect(() => {
    getPlayerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pageNumber,
    recordLength,
    changeDeviceType,
    searchEmail,
    changeStatus,
    testPage,
  ]);

  const getPlayerList = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/player/get-all-player-details`, {
        pageNumber: pageNumber,
        recordLength: recordLength,
        deviceType: parseInt(changeDeviceType),
        search: searchEmail,
        kycStatus: parseInt(changeStatus),
      })
      .then((response) => {
        setLoader(false);
        if (response.data.status) {
          setFilteredData(response.data.data.playerData);
          setTotalLength(response.data.data?.totalLength);
        } else {
          toast.error(response.data.message || "Failed to fetch players");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log("getBranch error :::", error);
        toast.error("Network error: Failed to fetch player list");
      });
  };

  const warningWithConfirmMessage = (e) => {
    console.log("warningWithConfirmMessage ---", e);
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        btnSize="md"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
        title=""
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete <b>{e.name || e.userName}</b>. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const errorMessageDialog = (message) => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => {
          setAlert(null);
          setButtonLoader(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">{message || "Something went wrong. Please try again later."}</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getPlayerList();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The player record has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);
    axios
      .get(`${API_URL}/api/admin/player/delete-player/${e._id}`)
      .then((res) => {
        console.log(res);
        console.log("res :::", res);
        const data = {
          playerId: e.playerId,
        };
        if (res.data.status) {
          successDeleted();
          socket.emit("PlayerDetailsDelete", data);
        }
      });
  };


  const clickEditButton = async (item) => {
    setShowPage(true);
    setValue(0);

    const getPlayerData = await axios.get(
      `${API_URL}/api/admin/player/get-single-player-details/${item._id}`
    );
    console.log("getPlayerData...", getPlayerData.data.data);
    setRowValue(getPlayerData.data.data.playerData);
    setHistoryData(getPlayerData.data.data.playerData.playerId);
  };

  const LoginSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().required("email required"),
    password: Yup.string().required("password is required"),
  });

  const successAdd = (message) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getPlayerList();
          setAlert(null);
          setAddNewPlayer(false);
          setButtonLoader(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{message || "The player record has been added successfully."}</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      <Dialog 
          open={showBotForm} 
          onClose={() => setShowBotForm(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: '20px',
              padding: '10px'
            }
          }}
        >
          <DialogTitle>
            <div className="d-flex justify-content-between align-items-center">
              <b style={{ fontSize: '1.5rem', color: '#1e293b' }}>Add New Bot</b>
              <IconButton onClick={() => setShowBotForm(false)} size="small">
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent>
            <Formik
              initialValues={{
                name: "",
                email: "",
                amount: "",
                image: 0,
              }}
              validationSchema={BotFormSchema}
              onSubmit={(values) => {
                setButtonLoader(true);
                axios
                  .post(`${API_URL}/api/admin/player/add-bot`, values)
                  .then((result) => {
                    setButtonLoader(false);
                    if (result.data.status === true) {
                      successAdd(result.data.message);
                      getPlayerList();
                      setShowBotForm(false);
                    } else {
                      errorMessageDialog(result.data.message);
                    }
                  })
                  .catch((err) => {
                    setButtonLoader(false);
                    console.log("Error adding bot:", err);
                    errorMessageDialog("Something went wrong");
                  });
              }}
            >
              {({ touched, errors, values }) => (
                <Form className="mt-2">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="font-weight-bold">Name <span className="text-danger">*</span></label>
                        <Field
                          type="text"
                          name="name"
                          placeholder="Enter bot name"
                          className={`form-control ${touched.name && errors.name ? "is-invalid" : ""}`}
                        />
                        <ErrorMessage component="div" name="name" className="invalid-feedback" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="font-weight-bold">Email <span className="text-danger">*</span></label>
                        <Field
                          type="email"
                          name="email"
                          placeholder="Enter bot email"
                          className={`form-control ${touched.email && errors.email ? "is-invalid" : ""}`}
                        />
                        <ErrorMessage component="div" name="email" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="font-weight-bold">Initial Amount <span className="text-danger">*</span></label>
                        <Field
                          type="number"
                          name="amount"
                          placeholder="0.00"
                          className={`form-control ${touched.amount && errors.amount ? "is-invalid" : ""}`}
                        />
                        <ErrorMessage component="div" name="amount" className="invalid-feedback" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <CustomSelect
                        label="Image Type"
                        name="image"
                        options={[
                          { value: 0, label: "Image 0" },
                          { value: 1, label: "Image 1" },
                          { value: 2, label: "Image 2" },
                          { value: 3, label: "Image 3" },
                        ]}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                    <button
                      type="button"
                      className="btn btn-secondary mr-2"
                      onClick={() => setShowBotForm(false)}
                      style={{ minWidth: '100px' }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={buttonLoader}
                      style={{ minWidth: '120px' }}
                    >
                      {buttonLoader ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-2"></span>
                          Saving...
                        </>
                      ) : (
                        "Add Bot"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>

        {addNewPlayer ? (
            <>
              <div class="content p-3 ">
                <div className="card p-3">
                  <Box sx={{ width: "100%" }}>
                    <Formik
                      initialValues={{
                        name: "",
                        email: "",
                        password: "",
                      }}
                      validationSchema={LoginSchema}
                      onSubmit={(values) => {
                        setButtonLoader(true);
                        axios(`${API_URL}/api/player/add-player`, {
                          method: "POST",
                          credentials: "include",
                          data: values,
                        })
                          .then((result) => {
                            console.log("handleSubmit result :::", result.data);
                            if (result.data.isValid === true) {
                              successAdd(result.data.message);
                            } else {
                              errorMessageDialog(result.data.message);
                            }
                          })
                          .catch((err) => {
                            console.log("handleSubmit err :::", err);
                            alert("something went wrong...");
                          });
                      }}
                    >
                      {({
                        touched,
                        errors,
                        isSubmitting,
                        values,
                        setFieldValue,
                      }) => (
                        <div>
                          <Form>
                            <div className="form-group">
                              <label htmlFor="password">Name</label>
                              <Field
                                type="text"
                                name="name"
                                placeholder="Name"
                                className={`mt-2 form-control
                          ${touched.name && errors.name ? "is-invalid" : ""}`}
                              />
                              <ErrorMessage
                                component="div"
                                name="name"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="password">Email</label>
                              <Field
                                type="text"
                                name="email"
                                placeholder="email"
                                className={`mt-2 form-control
                          ${touched.email && errors.email ? "is-invalid" : ""}`}
                              />
                              <ErrorMessage
                                component="div"
                                name="email"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="password">Password</label>
                              <Field
                                type="text"
                                name="password"
                                placeholder="Password"
                                className={`mt-2 form-control
                          ${
                            touched.password && errors.password
                              ? "is-invalid"
                              : ""
                          }`}
                              />
                              <ErrorMessage
                                component="div"
                                name="password"
                                className="invalid-feedback"
                              />
                            </div>

                            <div className="d-flex">
                              <button
                                style={{ width: "100px" }}
                                type="submit"
                                className="btn btn-primary btn-block mt-4 mr-2"
                                disabled={buttonLoader}
                              >
                                <div
                                  className="d-flex"
                                  style={{
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    className="d-flex"
                                    style={{
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <b>Submit</b>
                                  </div>
                                  {buttonLoader && (
                                    <div>
                                      <div
                                        class="spinner-border ml-2 mt-1"
                                        role="status"
                                        style={{
                                          height: "20px",
                                          width: "20px",
                                        }}
                                      ></div>
                                    </div>
                                  )}
                                </div>
                              </button>
                              <button
                                style={{ width: "100px" }}
                                onClick={() => setAddNewPlayer(false)}
                                type="button"
                                className="btn btn-secondary btn-block mt-4 ms-2"
                              >
                                Close
                              </button>
                            </div>
                          </Form>
                        </div>
                      )}
                    </Formik>
                  </Box>
                </div>
              </div>
            </>
          ) : (
            <>
              {showPage ? (
                <div class="content p-3 ">
                  <div className="card border-0 shadow-none p-4">
                    <div className="d-flex align-items-center mb-4">
                      <div 
                        className="courser mr-3" 
                        onClick={() => setShowPage(false)}
                        style={{ fontSize: '1.1rem', color: '#000' }}
                      >
                        <i className="fas fa-arrow-left"></i>
                      </div>
                      <h5 className="mb-0 font-weight-bold" style={{ color: '#1e293b', fontSize: '1.15rem' }}>
                        {rowValue?.name || "Player Details"}
                      </h5>
                    </div>
                    <Box sx={{ width: "100%" }}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                          value={value}
                          onChange={handleChange}
                          aria-label="basic tabs example"
                          scrollButtons="auto"
                          variant="scrollable"
                        >
                          <Tab
                            label="Home"
                            {...a11yProps(0)}
                            style={{ width: "190px" }}
                          />
                          <Tab
                            label="Ticket"
                            {...a11yProps(1)}
                            style={{ width: "190px" }}
                          />
                          <Tab
                            label="KYC Player"
                            {...a11yProps(2)}
                            style={{ width: "190px" }}
                          />
                          <Tab
                            label="Other Details"
                            {...a11yProps(3)}
                            style={{ width: "190px" }}
                          />
                          <Tab
                            label="Notification"
                            {...a11yProps(4)}
                            style={{ width: "190px" }}
                          />
                          <Tab
                            label="History List"
                            {...a11yProps(5)}
                            style={{ width: "190px" }}
                          />
                          <Tab
                            label="Refferal List"
                            {...a11yProps(6)}
                            style={{ width: "190px" }}
                          />
                          <Tab
                            label="Test"
                            {...a11yProps(7)}
                            style={{ width: "190px" }}
                          />
                        </Tabs>
                      </Box>

                      <TabPanel value={value} index={0}>
                        <Home rowValue={rowValue} />
                      </TabPanel>
                      <TabPanel value={value} index={1}>
                        <Ticket id={rowValue?._id} />
                      </TabPanel>
                      <TabPanel value={value} index={2}>
                        <VerifiedPlayer rowValue={rowValue} />
                      </TabPanel>
                      <TabPanel value={value} index={3}>
                        <OtherDetails rowValue={rowValue} />
                      </TabPanel>
                      <TabPanel value={value} index={4}>
                        <Notification
                          notificationToken={rowValue?.notificationToken}
                          rowValue={rowValue}
                        />
                      </TabPanel>
                      <TabPanel value={value} index={5}>
                        <History historyData={historyData} />
                      </TabPanel>
                      <TabPanel value={value} index={6}>
                        <RefferalList id={rowValue?._id} />
                      </TabPanel>
                      <TabPanel value={value} index={7}>
                        <Test
                          rowValue={rowValue}
                          setTestPage={setTestPage}
                          testPage={testPage}
                        />
                      </TabPanel>
                    </Box>
                  </div>
                </div>
              ) : (
                <div className="content p-3">
                  <div class="card ">
                    <div className="pl-4 pr-4 pt-4">
                      <div className="row align-items-end">
                        <div className="col-md-2">
                          <label className="small text-muted font-weight-bold mb-1">KYC Status</label>
                          <Select
                            styles={filterSelectStyles}
                            options={[
                              { value: 3, label: "All" },
                              { value: 2, label: "Not Verified" },
                              { value: 0, label: "Pending" },
                              { value: 1, label: "Verified" },
                            ]}
                            value={{
                              value: changeStatus,
                              label: changeStatus === 3 ? "All" : changeStatus === 2 ? "Not Verified" : changeStatus === 0 ? "Pending" : "Verified"
                            }}
                            onChange={(option) => {
                              setPageNumber(1);
                              setRecordLength(10);
                              setChangeStatus(option.value);
                            }}
                          />
                        </div>
                        <div className="col-md-2">
                          <label className="small text-muted font-weight-bold mb-1">Device Type</label>
                          <Select
                            styles={filterSelectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            options={[
                              { value: 2, label: "All" },
                              { value: 0, label: "Android" },
                              { value: 1, label: "IOS" },
                            ]}
                            value={{
                              value: changeDeviceType,
                              label: changeDeviceType === 2 ? "All" : changeDeviceType === 0 ? "Android" : "IOS"
                            }}
                            onChange={(option) => {
                              setPageNumber(1);
                              setRecordLength(10);
                              setChangeDeviceType(option.value);
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="small text-muted font-weight-bold mb-1">Search Player</label>
                          <div className="position-relative">
                            <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                            <input
                              className="form-control premium-search-input"
                              type="text"
                              placeholder="Email or Name..."
                              value={searchEmail}
                              onChange={(e) => {
                                setPageNumber(1);
                                setRecordLength(10);
                                setSearchEmail(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-5 d-flex justify-content-end align-items-end mt-3 mt-md-0" style={{ gap: '12px' }}>
                          <button
                            type="button"
                            className="btn btn-premium-outline"
                            onClick={handleClearFilters}
                          >
                            Clear Filter
                          </button>
                          <button
                            className="btn btn-premium-primary"
                            onClick={() => setShowBotForm(true)}
                          >
                            Add Bot
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body" style={{ overflow: "scroll" }}>
                      <table id="" class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>SrNo</th>
                            <th style={{ textAlign: "center" }}>Id</th>
                            <th style={{ textAlign: "center" }}>Date</th>
                            <th style={{ textAlign: "center" }}>Name</th>
                            <th style={{ textAlign: "center" }}>Email</th>
                            <th style={{ textAlign: "center" }}>Device Type</th>
                            <th style={{ textAlign: "center" }}>KYC Status</th>
                            <th style={{ textAlign: "center" }}>Balance</th>
                            <th style={{ textAlign: "center" }}>Status</th>
                            {(accessObject?.playerListEdit === true ||
                              accessObject?.playerListDelete === true) && (
                              <th style={{ textAlign: "center" }}>Action</th>
                            )}
                          </tr>
                        </thead>
                        {accessObject?.getPlayerList === true ? (
                          <>
                            <tbody>
                              {!loader ? (
                                <>
                                  {filteredData.length > 0 ? (
                                    <>
                                      {filteredData?.map((item, index) => {
                                        return (
                                          <>
                                            <tr key={index}>
                                              <td>
                                                {pageNumber === 1
                                                  ? index + 1
                                                  : index +
                                                    1 +
                                                    pageNumber * recordLength -
                                                    recordLength}
                                              </td>
                                              <td>{item.playerId}</td>
                                              <td>
                                                {moment(item.createdAt).format(
                                                  "DD/MM/YYYY"
                                                )}
                                              </td>
                                              <td>{item.name || "-"}</td>
                                              <td>{item.email || "-"}</td>
                                              <td>
                                                {item.deviceType === 0
                                                  ? "Android"
                                                  : item.deviceType === 1
                                                  ? "IOS"
                                                  : "-"}
                                              </td>
                                              <td>
                                                {item.kycStatus === 0
                                                  ? "Pending"
                                                  : item.kycStatus === 1
                                                  ? "Verified"
                                                  : item.kycStatus === 2
                                                  ? "Not Verified"
                                                  : "-"}
                                              </td>
                                              <td>
                                                {item.depositeBalance +
                                                  item.withdrawBalance +
                                                  item.bonusBalance}
                                              </td>
                                              <td>
                                                {item.playerStatus === 0 &&
                                                  "Active"}
                                                {item.playerStatus === 1 &&
                                                  "Banned"}
                                                {item.playerStatus === 2 &&
                                                  "Deleted"}
                                              </td>
                                              {(accessObject?.playerListEdit ===
                                                true ||
                                                accessObject?.playerListDelete ===
                                                  true) && (
                                                <td className="justify-content-evenly ">
                                                  <div className="d-flex">
                                                    {accessObject?.playerListEdit ===
                                                      true && (
                                                      <EditIcon
                                                        className="mr-3 courser"
                                                        onClick={() =>
                                                          clickEditButton(item)
                                                        }
                                                      />
                                                    )}
                                                    {accessObject?.playerListDelete ===
                                                      true && (
                                                      <ClearIcon
                                                        className="courser text-danger"
                                                        onClick={() =>
                                                          warningWithConfirmMessage(
                                                            item
                                                          )
                                                        }
                                                      />
                                                    )}
                                                  </div>
                                                </td>
                                              )}
                                            </tr>
                                          </>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <EmptyState colSpan={10} message="No Players Found" subMessage="We couldn't find any player records matching your criteria." />
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                            </tbody>
                          </>
                        ) : (
                          <>
                            <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                              <td colSpan={8}>
                                <h5 className="text-center">Access Denied</h5>
                              </td>
                            </tr>
                          </>
                        )}
                      </table>
                      {accessObject?.getPlayerList === true && (
                        <div className="mt-4">{loader && <Loader />}</div>
                      )}
                    </div>
                    {accessObject?.getPlayerList === true &&
                      filteredData.length !== 0 && (
                        <div>
                          <Pagination
                            updateShowPerpagevalue={updateShowPerpagevalue}
                            showPrePage={showPrePage}
                            onPaginationChange={onPaginationChange}
                            total={filteredData.length}
                            paginationTypeApi={true}
                            pageNumber={pageNumber}
                            setPageNumber={setPageNumber}
                            recordLength={recordLength}
                            setRecordLength={setRecordLength}
                            totalLength={totalLength}
                          />
                        </div>
                      )}
                  </div>
                </div>
              )}
            </>
          )}
    </>
  );
}
